import { render, staticRenderFns } from "./EquipmentRecordDialog.vue?vue&type=template&id=5c6228e4&scoped=true&"
import script from "./EquipmentRecordDialog.vue?vue&type=script&lang=js&"
export * from "./EquipmentRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6228e4",
  null
  
)

export default component.exports